/** Warehouse reports (plan 5.12, FR-INV-26). */
const en = {
  nav: { warehouseReports: "Warehouse Reports" },
  whReports: {
    title: "Warehouse Reports",
    subtitle: "Stock status, movements, turnover, count variances, occupancy and shipment performance",
    from: "From",
    to: "To",
    warehouse: "Warehouse",
    allWarehouses: "All warehouses",
    refresh: "Refresh",
    exportCsv: "CSV",
    exportXlsx: "Excel",
    loadError: "Report data could not be loaded.",
    empty: "No rows for this filter.",
    moreRows: "Showing the first {{shown}} of {{total}} rows; the export contains all.",
    onlyDifferences: "Only differences",
    reports: {
      stockStatus: "Stock status",
      movementLedger: "Movement ledger",
      turnover: "Turnover",
      countVariance: "Count variances",
      occupancy: "Location occupancy",
      shipmentPerformance: "Shipment performance"
    },
    summary: {
      products: "Products", value: "Stock value", out: "Out of stock", low: "Below minimum",
      movements: "Movements", in: "In", outQty: "Out", transfers: "Transfers",
      days: "Days", averageAnnualTurnover: "Avg. annual turnover", dead: "Dead stock",
      linesCounted: "Lines counted", variances: "Variances", accuracyPct: "Accuracy %", netValue: "Net value", absValue: "Absolute value",
      locations: "Locations", empty: "Empty", full: "Full", averagePct: "Avg. occupancy %",
      shipped: "Shipped", onTimePct: "On time %", averageLeadDays: "Avg. lead time (days)", averageTransitDays: "Avg. transit (days)", overdue: "Overdue"
    },
    col: {
      sku: "SKU", name: "Product", unit: "Unit", onHand: "On hand", reserved: "Reserved", quarantine: "Quarantine", inTransit: "In transit",
      available: "Available", minStock: "Minimum", status: "Status", unitCost: "Unit cost", value: "Value",
      date: "Date", type: "Type", in: "In", out: "Out", moved: "Transferred", balance: "Balance", from: "From", to: "To", reference: "Reference",
      opening: "Opening", closing: "Closing", average: "Average", issued: "Issued", turnover: "Turnover", annualTurnover: "Annual turnover",
      daysOfInventory: "Days of inventory", class: "Class",
      count: "Count", countStatus: "Count status", warehouse: "Warehouse", systemQty: "System", countedQty: "Counted", diff: "Difference", pct: "%",
      warehouseId: "Warehouse", code: "Code", path: "Path", units: "Units", unitsCapacity: "Unit capacity", volumeM3: "Volume m³",
      volumeCapacity: "Volume capacity", weightKg: "Weight kg", weightCapacity: "Weight capacity",
      order: "Order", customer: "Customer", requestedDate: "Requested", orderedAt: "Ordered", dispatchedAt: "Dispatched",
      deliveredAt: "Delivered", leadDays: "Lead (days)", transitDays: "Transit (days)", delayDays: "Delay (days)", carrier: "Carrier"
    },
    status: {
      ok: "OK", low: "Low", out: "Out", posted: "Posted", reversed: "Reversed", in_transit: "In transit",
      fast: "Fast", normal: "Normal", slow: "Slow", dead: "Dead",
      empty: "Empty", unbounded: "No capacity", high: "High", full: "Full",
      onTime: "On time", late: "Late", overdue: "Overdue", noDate: "No date"
    }
  }
};

const tr = {
  nav: { warehouseReports: "Depo Raporları" },
  whReports: {
    title: "Depo Raporları",
    subtitle: "Stok durumu, hareketler, devir hızı, sayım farkları, doluluk ve sevkiyat performansı",
    from: "Başlangıç",
    to: "Bitiş",
    warehouse: "Depo",
    allWarehouses: "Tüm depolar",
    refresh: "Yenile",
    exportCsv: "CSV",
    exportXlsx: "Excel",
    loadError: "Rapor verileri yüklenemedi.",
    empty: "Bu filtre için satır yok.",
    moreRows: "{{total}} satırın ilk {{shown}} tanesi gösteriliyor; dışa aktarım hepsini içerir.",
    onlyDifferences: "Yalnız farklar",
    reports: {
      stockStatus: "Stok durumu",
      movementLedger: "Hareket dökümü",
      turnover: "Devir hızı",
      countVariance: "Sayım farkları",
      occupancy: "Lokasyon doluluğu",
      shipmentPerformance: "Sevkiyat performansı"
    },
    summary: {
      products: "Ürün", value: "Stok değeri", out: "Stokta yok", low: "Minimumun altında",
      movements: "Hareket", in: "Giriş", outQty: "Çıkış", transfers: "Transfer",
      days: "Gün", averageAnnualTurnover: "Ort. yıllık devir", dead: "Ölü stok",
      linesCounted: "Sayılan satır", variances: "Fark", accuracyPct: "Doğruluk %", netValue: "Net tutar", absValue: "Mutlak tutar",
      locations: "Lokasyon", empty: "Boş", full: "Dolu", averagePct: "Ort. doluluk %",
      shipped: "Sevk edilen", onTimePct: "Zamanında %", averageLeadDays: "Ort. hazırlık (gün)", averageTransitDays: "Ort. yolda (gün)", overdue: "Geciken"
    },
    col: {
      sku: "Stok kodu", name: "Ürün", unit: "Birim", onHand: "Eldeki", reserved: "Rezerve", quarantine: "Karantina", inTransit: "Yolda",
      available: "Kullanılabilir", minStock: "Minimum", status: "Durum", unitCost: "Birim maliyet", value: "Tutar",
      date: "Tarih", type: "Tür", in: "Giriş", out: "Çıkış", moved: "Transfer", balance: "Bakiye", from: "Kaynak", to: "Hedef", reference: "Referans",
      opening: "Açılış", closing: "Kapanış", average: "Ortalama", issued: "Çıkan", turnover: "Devir", annualTurnover: "Yıllık devir",
      daysOfInventory: "Stok gün sayısı", class: "Sınıf",
      count: "Sayım", countStatus: "Sayım durumu", warehouse: "Depo", systemQty: "Sistem", countedQty: "Sayılan", diff: "Fark", pct: "%",
      warehouseId: "Depo", code: "Kod", path: "Yol", units: "Adet", unitsCapacity: "Adet kapasitesi", volumeM3: "Hacim m³",
      volumeCapacity: "Hacim kapasitesi", weightKg: "Ağırlık kg", weightCapacity: "Ağırlık kapasitesi",
      order: "Sipariş", customer: "Müşteri", requestedDate: "İstenen", orderedAt: "Sipariş tarihi", dispatchedAt: "Sevk",
      deliveredAt: "Teslim", leadDays: "Hazırlık (gün)", transitDays: "Yolda (gün)", delayDays: "Gecikme (gün)", carrier: "Taşıyıcı"
    },
    status: {
      ok: "Normal", low: "Düşük", out: "Yok", posted: "İşlendi", reversed: "Ters kayıt", in_transit: "Yolda",
      fast: "Hızlı", normal: "Normal", slow: "Yavaş", dead: "Ölü",
      empty: "Boş", unbounded: "Kapasite yok", high: "Yüksek", full: "Dolu",
      onTime: "Zamanında", late: "Geç", overdue: "Gecikmiş", noDate: "Tarih yok"
    }
  }
};

const ar = {
  nav: { warehouseReports: "تقارير المستودع" },
  whReports: {
    title: "تقارير المستودع",
    subtitle: "حالة المخزون والحركات ومعدل الدوران وفروق الجرد والإشغال وأداء الشحن",
    from: "من",
    to: "إلى",
    warehouse: "المستودع",
    allWarehouses: "كل المستودعات",
    refresh: "تحديث",
    exportCsv: "CSV",
    exportXlsx: "Excel",
    loadError: "تعذر تحميل بيانات التقرير.",
    empty: "لا توجد صفوف لهذا الفلتر.",
    moreRows: "عرض أول {{shown}} من {{total}} صفًا؛ التصدير يتضمن الكل.",
    onlyDifferences: "الفروق فقط",
    reports: {
      stockStatus: "حالة المخزون",
      movementLedger: "سجل الحركات",
      turnover: "معدل الدوران",
      countVariance: "فروق الجرد",
      occupancy: "إشغال المواقع",
      shipmentPerformance: "أداء الشحن"
    },
    summary: {
      products: "المنتجات", value: "قيمة المخزون", out: "نفد المخزون", low: "أقل من الحد الأدنى",
      movements: "الحركات", in: "وارد", outQty: "صادر", transfers: "تحويلات",
      days: "الأيام", averageAnnualTurnover: "متوسط الدوران السنوي", dead: "مخزون راكد",
      linesCounted: "بنود مجرودة", variances: "فروق", accuracyPct: "الدقة %", netValue: "القيمة الصافية", absValue: "القيمة المطلقة",
      locations: "المواقع", empty: "فارغ", full: "ممتلئ", averagePct: "متوسط الإشغال %",
      shipped: "تم الشحن", onTimePct: "في الموعد %", averageLeadDays: "متوسط التجهيز (أيام)", averageTransitDays: "متوسط النقل (أيام)", overdue: "متأخر"
    },
    col: {
      sku: "رمز الصنف", name: "المنتج", unit: "الوحدة", onHand: "المتوفر", reserved: "محجوز", quarantine: "حجر", inTransit: "قيد النقل",
      available: "المتاح", minStock: "الحد الأدنى", status: "الحالة", unitCost: "تكلفة الوحدة", value: "القيمة",
      date: "التاريخ", type: "النوع", in: "وارد", out: "صادر", moved: "محوّل", balance: "الرصيد", from: "من", to: "إلى", reference: "المرجع",
      opening: "الافتتاحي", closing: "الختامي", average: "المتوسط", issued: "المصروف", turnover: "الدوران", annualTurnover: "الدوران السنوي",
      daysOfInventory: "أيام المخزون", class: "الفئة",
      count: "الجرد", countStatus: "حالة الجرد", warehouse: "المستودع", systemQty: "النظام", countedQty: "المجرود", diff: "الفرق", pct: "%",
      warehouseId: "المستودع", code: "الرمز", path: "المسار", units: "الوحدات", unitsCapacity: "سعة الوحدات", volumeM3: "الحجم م³",
      volumeCapacity: "سعة الحجم", weightKg: "الوزن كغ", weightCapacity: "سعة الوزن",
      order: "الطلب", customer: "العميل", requestedDate: "المطلوب", orderedAt: "تاريخ الطلب", dispatchedAt: "الشحن",
      deliveredAt: "التسليم", leadDays: "التجهيز (أيام)", transitDays: "النقل (أيام)", delayDays: "التأخير (أيام)", carrier: "الناقل"
    },
    status: {
      ok: "طبيعي", low: "منخفض", out: "نفد", posted: "مرحّل", reversed: "معكوس", in_transit: "قيد النقل",
      fast: "سريع", normal: "عادي", slow: "بطيء", dead: "راكد",
      empty: "فارغ", unbounded: "بلا سعة", high: "مرتفع", full: "ممتلئ",
      onTime: "في الموعد", late: "متأخر", overdue: "متأخر الاستحقاق", noDate: "بلا تاريخ"
    }
  }
};

export const warehouseReportLocales = { en, tr, ar };
